import { render, staticRenderFns } from "./appContainer.vue?vue&type=template&id=62546d4c&"
import script from "./appContainer.vue?vue&type=script&lang=js&"
export * from "./appContainer.vue?vue&type=script&lang=js&"
import style0 from "./appContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports